"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = DialogHeader;

var _AlertMedium = _interopRequireDefault(require("../../Icon/core/AlertMedium"));

var _Button = _interopRequireDefault(require("../../Button"));

var _classnames = _interopRequireDefault(require("classnames"));

var _CrossLarge = _interopRequireDefault(require("../../Icon/core/CrossLarge"));

var _DialogButtons = _interopRequireDefault(require("./DialogButtons"));

var _filterDOMProps = _interopRequireDefault(require("../../utils/filterDOMProps"));

var _Heading = _interopRequireDefault(require("../../Heading"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var VARIANT_ICONS = {
  error: _AlertMedium["default"]
};

function DialogHeader(_ref) {
  var title = _ref.title,
      variant = _ref.variant,
      fullscreen = _ref.fullscreen,
      confirmDisabled = _ref.confirmDisabled,
      confirmLabel = _ref.confirmLabel,
      secondaryLabel = _ref.secondaryLabel,
      cancelLabel = _ref.cancelLabel,
      onConfirm = _ref.onConfirm,
      onCancel = _ref.onCancel,
      onClose = _ref.onClose,
      className = _ref.className,
      autoFocusButton = _ref.autoFocusButton,
      id = _ref.id,
      isDismissible = _ref.isDismissible,
      otherProps = _objectWithoutProperties(_ref, ["title", "variant", "fullscreen", "confirmDisabled", "confirmLabel", "secondaryLabel", "cancelLabel", "onConfirm", "onCancel", "onClose", "className", "autoFocusButton", "id", "isDismissible"]);

  var Icon = VARIANT_ICONS[variant];
  return _react["default"].createElement("div", _extends({}, (0, _filterDOMProps["default"])(otherProps), {
    className: (0, _classnames["default"])('spectrum-Dialog-header', "spectrum-Dialog-header--".concat(variant), className)
  }), _react["default"].createElement(_Heading["default"], {
    size: 3,
    className: "spectrum-Dialog-title",
    id: id
  }, title), Icon && _react["default"].createElement(Icon, {
    size: null,
    className: "spectrum-Dialog-typeIcon"
  }), isDismissible && !fullscreen && _react["default"].createElement(_Button["default"], {
    className: "spectrum-Dialog-closeButton",
    variant: "action",
    onClick: onClose,
    quiet: true,
    icon: _react["default"].createElement(_CrossLarge["default"], {
      size: "L"
    })
  }), fullscreen && confirmLabel && _react["default"].createElement(_DialogButtons["default"], {
    autoFocusButton: autoFocusButton,
    variant: variant,
    cancelLabel: cancelLabel,
    secondaryLabel: secondaryLabel,
    confirmLabel: confirmLabel,
    confirmDisabled: confirmDisabled,
    onConfirm: onConfirm,
    onCancel: onCancel
  }));
}